/* eslint-disable */
import React from 'react';
import { Container, Form } from 'reactstrap';

import changePassword from '../../auth/changePassword';
import SITE_PATHS from '../../config/sitePaths';
import Text from '../../components/Text';

import PasswordInputFormGroup from './PasswordInputFormGroup';
import PasswordRequirementsFormGroup from './PasswordRequirementsFormGroup';
import FooterFormGroup from './FooterFormGroup';

import styles from './styles';

class ChangePassword extends React.Component {
  state = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    errors: { },
  };

  onSubmit = () => () => {
    const errors = {};

    if (this.state.newPassword !== this.state.confirmPassword) {
      errors.confirmPassword = 'Password dont match';
      this.setState({ errors });
      this.state.newPassword = '';
      this.state.confirmPassword = '';
      return;
    }

    this.changeCurrentUsersPassword(this.state.oldPassword, this.state.newPassword);
  };

  changeCurrentUsersPassword = (oldPassword, newPassword) => {
    changePassword(oldPassword, newPassword)
      .then(() => {
        window.location = SITE_PATHS.SIGN_IN;
      })
      .catch(error => {
        if (/validation error detected/.test(error.message)) {
          this.setState({ errors: { newPassword: 'Password requirements not met' } });
        } else {
          this.setState({ errors: { oldPassword: error.message } });
        }
      });
  };

  updateStateFromUserInput = (inputType, value) => {
    this.setState({
      [inputType]: value,
      errors: {
        ...this.state.errors,
        [inputType]: undefined,
      },
    });
  };

  createOldPasswordProps() {
    return {
      errorMessage: this.state.errors.oldPassword,
      onUserInput: this.updateStateFromUserInput,
      fieldName: 'oldPassword',
      topDefaultLabel: 'Current Password',
      bottomDefaultLabel: 'Enter Current Password',
    };
  };

  createNewPasswordProps() {
    return {
      errorMessage: this.state.errors.newPassword,
      onUserInput: this.updateStateFromUserInput,
      fieldName: 'newPassword',
      topDefaultLabel: 'New Password',
      bottomDefaultLabel: 'Enter New Password',
    };
  };

  createConfirmPasswordProps() {
    return {
      errorMessage: this.state.errors.confirmPassword,
      onUserInput: this.updateStateFromUserInput,
      fieldName: 'confirmPassword',
      topDefaultLabel: 'Confirm Password',
      bottomDefaultLabel: 'Enter Password Again',
    };
  };

  createFooterProps() {
    return {
      buttonLabel: 'Set New Password',
      onSubmit: this.onSubmit(),
    };
  };
  
  render() {
    return (
      <Container style={styles.formContainer}>
        <h1 style={styles.formTitle}>
          <Text value="Change Password"/>
        </h1>
        <Form>
          <PasswordInputFormGroup {...this.createOldPasswordProps()} />
          <PasswordRequirementsFormGroup />
          <PasswordInputFormGroup {...this.createNewPasswordProps()} />
          <PasswordInputFormGroup {...this.createConfirmPasswordProps()} />
          <FooterFormGroup {...this.createFooterProps()} />
        </Form>
      </Container>
    )
  }
}

export default ChangePassword;
